import { render } from "./klb-q3.vue?vue&type=template&id=1117a4d0&scoped=true"
import script from "./klb-q3.vue?vue&type=script&lang=js"
export * from "./klb-q3.vue?vue&type=script&lang=js"

import "./klb-q3.vue?vue&type=style&index=0&id=1117a4d0&scoped=true&lang=css"

import exportComponent from "E:\\vue_yclcp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1117a4d0"]])

export default __exports__